<template>
    <!-- Theme one -->
    <ErrorNoticeOne v-if="themeStore.themeIndex === 1" @goToHome="goToHome" />
    <!-- Theme two -->
    <ErrorNoticeTwo v-if="themeStore.themeIndex === 2" @goToHome="goToHome" />
</template>

<script setup lang="ts">
import CustomHeader from '@/components/common/customHeader.vue';
import { useThemeStore } from '@/stores/theme';
import ErrorNoticeOne from '@/themes/themeOne/Notice/errorNotice.vue';
import ErrorNoticeTwo from '@/themes/themeTwo/Notice/errorNotice.vue';
import { useRouter } from 'vue-router';

const themeStore = useThemeStore()
const router = useRouter()
const goToHome = () => {
    router.push('/home')
}

</script>